import { CampaignType, Role, CampaignTypeLabel } from '@models';

export interface Path {
    name: string;
    path?: string;
    view?: string;
    meta?: PathMetaData;
    props?: any;
    children?: Path[];
    //Determines if the menuitem should just be a header for child items.
    title?: boolean;
}

export interface PathMetaData {
    role?: Role;
    displayInMenu?: boolean;
    icon?: string;
    skipAuthCheck?: boolean;
    isStandaloneView?: boolean;
}

export var paths: Path[] = [
    {
        name: 'Frontpage',
        path: '/',
        view: 'frontpage',
        meta: {
            displayInMenu: false
        }
    },
    {
        name: 'Dashboard',
        path: '/dashboard',
        view: 'Dashboard',
        meta: {
            role: Role.Advertiser,
            icon: 'mdi-view-dashboard',
            displayInMenu: true
        }
    },
    {
        name: 'Callback',
        path: '/callback',
        view: 'authentication/callback',
        meta: {
            displayInMenu: false,
            skipAuthCheck: true
        }
    },
    {
        name: 'Silent Renew',
        path: '/silent-renew',
        view: 'authentication/silentrenew',
        meta: {
            displayInMenu: false,
            skipAuthCheck: true,
            isStandaloneView: true,
        }
    },
    { // allow editing of legacy campaigns still
        name: 'Edit Campaign',
        path: '/edit_campaign',
        view: 'formats/Edit/EditExistingAd',
        meta: {
            role: Role.CreativeAdmin,
            displayInMenu: false
        }
    },
    { // allow creation of hosting in special new secret endpoint
        name: CampaignTypeLabel.get(CampaignType.hosting),
        path: '/hosting-secret-backdoor',
        view: 'formats/Hosting_format',
        meta: {
            displayInMenu: false
        },
        props: route => ({
            type: CampaignType.hosting,
            role: Role.CreativeAdmin,
            copyId: route.query.copyId ? parseInt(route.query.copyId) : null,
        })
    },
    { // allow create of new format from generic format list - to allow Creative Admins to test new formats
        name: 'Create Campaign',
        path: '/createcampaign',
        view: 'campaign/CampaignEditor',
        props: route => {
            return {
                formatId: route.query.formatId ? route.query.formatId : null,
            }
        },
        meta: {
            role: Role.CreativeAdmin,
            displayInMenu: false,
        }
    },
    {
        name: 'Admin',
        title: true,
        meta: {
            icon: 'mdi-server-security',
            role: Role.Administrator,
            displayInMenu: true
        },
        children: [
            {
                name: 'Organizations',
                path: '/list_organizations',
                view: 'admin/ListOrganizations',
                meta: {
                    role: Role.Administrator,
                    displayInMenu: true
                }
            },
            {
                name: 'Users',
                path: '/list_users',
                view: 'admin/ListUsers',
                meta: {
                    role: Role.Administrator,
                    displayInMenu: true
                }
            },
            {
                name: 'Consent Items',
                path: '/consent/list_consent',
                view: 'admin/Consent/ListConsent',
                meta: {
                    role: Role.Administrator,
                    displayInMenu: true
                }
            },
        ]
    },
    {
        name: 'Creative Admin',
        title: true,
        meta: {
            icon: 'mdi-server-security',
            role: Role.CreativeAdmin,
            displayInMenu: true
        },
        children: [
            {
                name: 'Generic Formats',
                path: '/listformats',
                view: 'format/FormatsList',
                meta: {
                    role: Role.CreativeAdmin,
                    displayInMenu: true,
                    icon: 'mdi-desktop-mac-dashboard'
                }
            },
            {
                name: 'Campaign List',
                path: '/campaign_list',
                view: 'formats/Edit/ListAds',
                meta: {
                    icon: 'mdi-table-of-contents',
                    role: Role.CreativeAdmin,
                    displayInMenu: true
                }
            },
            {
                name: 'Edit Existing Format',
                path: '/editformat',
                view: 'format/FormatEditor',
                props: route => {
                    return {
                        formatIdDefault: route?.query?.formatId || null,
                    }
                },
                meta: {
                    role: Role.CreativeAdmin,
                    displayInMenu: false,
                }
            },
        ]
    },
    {
        name: 'Edit organization',
        path: '/edit_organization',
        view: 'admin/EditOrganization',
        meta: {
            role: Role.Administrator,
            displayInMenu: false
        }
    },
    {
        name: 'Consent Details',
        path: '/consent/details/:id',
        view: 'consent/ConsentDetails',
        meta: {
            displayInMenu: false
        }
    }
];
